// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__TbLfc","active":"Pagination_active__KJFvO"};